<div
  cdkDropList
  class="levels-container"
  (cdkDropListDropped)="drop($event)"
  cdkDropListOrientation="vertical">
  
  @for (level of draggableLevels; track level.type; let i = $index) {
    <div 
      cdkDrag 
      [cdkDragData]="level" 
      [cdkDragDisabled]="!isDraggable(level)">
      
      <div class="level-container">
        <div class="d-flex align-items-center justify-content-between">
          <span class="p-2">{{ level.type }}</span>
          <div class="d-flex gap-1 align-items-center">
            <a
              *ngIf="isConfigurable(level)"
              role="button"
              class="p-2 text-dark text-decoration-none"
              (click)="toggleConfig(level)">
              Configure
            </a>
            <button 
              *ngIf="isDraggable(level)"
              class="btn p-2 btn-drag" 
              cdkDragHandle>
              ⋮⋮
            </button>
          </div>
        </div>

        <!-- Configuration accordion -->
        <div *ngIf="isConfigurable(level) && !isLevelCollapsed(level.type)" class="level-config p-3 border-top">

          <!-- Brand: Ordering Method (RSP, Sales, Volume) + Direction -->
          <ng-container *ngIf="level.type === 'Brand'">
            <div class="row mb-2">
              <label class="col-sm-4 col-form-label">Ordering Method</label>
              <div class="col-sm-8">
                <select 
                  class="form-select" 
                  [value]="level.orderingMethod"
                  (change)="setOrderingMethod(level, $event)">
                  <option value="-1">Select Method</option>
                  <option value="1">Brand RSP</option>
                  <option value="2">Sales</option>
                  <option value="3">Volume</option>
                  <option value="4">Max RSP</option>
                </select>
              </div>
            </div>
            <div class="row mb-2">
              <label class="col-sm-4 col-form-label">Ordering Direction</label>
              <div class="col-sm-8">
                <select 
                  class="form-select" 
                  [value]="level.orderingDirection"
                  (change)="setOrderingDirection(level, $event)">
                  <option value="0">Ascending</option>
                  <option value="1">Descending</option>
                </select>
              </div>
            </div>
          </ng-container>

          <!-- Height: Only Ordering Direction -->
          <ng-container *ngIf="level.type === 'Height'">
            <div class="row mb-2">
              <label class="col-sm-4 col-form-label">Ordering Direction</label>
              <div class="col-sm-8">
                <select 
                  class="form-select" 
                  [value]="level.orderingDirection"
                  (change)="setOrderingDirection(level, $event)">
                  <option value="0">Ascending</option>
                  <option value="1">Descending</option>
                </select>
              </div>
            </div>
          </ng-container>

        </div>
      </div>

      <!-- Variant always under Brand -->
      <div 
        *ngIf="level.type === 'Brand' && displayVariantLevel" 
        class="level-container variant-attached">
        <div class="d-flex align-items-center justify-content-between">
          <span class="p-2">Variant</span>
          <a
            role="button"
            class="p-2 text-dark text-decoration-none"
            (click)="toggleConfig(displayVariantLevel)">
            Configure
          </a>
        </div>

        <!-- Configuration accordion for Variant -->
        <div *ngIf="!isLevelCollapsed('Variant')" class="level-config p-3 border-top">
          <div class="row mb-2">
            <label class="col-sm-4 col-form-label">Ordering Method</label>
            <div class="col-sm-8">
              <select 
                class="form-select" 
                [value]="displayVariantLevel.orderingMethod"
                (change)="setOrderingMethod(displayVariantLevel, $event)">
                <option value="0">Select Method</option>
                <option value="2">Sales</option>
                <option value="3">Volume</option>
              </select>
            </div>
          </div>
          <div class="row mb-2">
            <label class="col-sm-4 col-form-label">Ordering Direction</label>
            <div class="col-sm-8">
              <select 
                class="form-select" 
                [value]="displayVariantLevel.orderingDirection"
                (change)="setOrderingDirection(displayVariantLevel, $event)">
                <option value="0">Ascending</option>
                <option value="1">Descending</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
}
</div>